export default [
  {
    id: '3-1',
    parentId: '0',
    title: '达人库',
    name: 'services-expert',
    path: '/services/expert',
    type: 2,
    component: '/services/expert/expert-list/expert-list',
    isHidden: false,
    icon: 'kl-expert-library'
  },
  {
    id: '3-2',
    parentId: '0',
    title: '达人详情-新增',
    path: '/services/expert/page-add',
    type: 2,
    component: '/services/expert/all-c-pages/expert-add-or-edit/expert-add-or-edit',
    isHidden: true,
    icon: 'kl-expert-library'
  },
  {
    id: '3-3',
    parentId: '0',
    title: '达人详情-修改',
    path: '/services/expert/page-edit',
    type: 2,
    component: '/services/expert/all-c-pages/expert-add-or-edit/expert-add-or-edit',
    isHidden: true,
    icon: 'kl-expert-library'
  }
]
